module.exports = __webpack_public_path__ + "img/icon_water_logo.0597a43d.png";